module.exports = __webpack_public_path__ + "static/img/ba.8d9a86c2.svg";